import { Component, Inject, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DataSourceOptions } from 'devextreme/data/data_source';
import { ABaseComponent } from 'src/app/shared/modules/ui/components/abstract/a-base.component';
import { DataSourceService } from '../../../../shared/modules/my-common/services/datasource.service';
import { UiService } from '../../../../shared/modules/ui/services/ui.service';
import { LoggerService, LoopBackAuth, VehicleService, VehicleServiceApi } from '../../../../shared/sdk';
import notify from 'devextreme/ui/notify';
import { HelperService } from '../../services/helper.service';
import { ExtLoopBackAuth } from 'src/app/shared/modules/ext-sdk/services/ext-sdk-auth.service';

@Component({
  selector: 'app-vehicle-service-details-tab-requests',
  templateUrl: './vehicle-service-details-tab-requests.component.html',
  styleUrls: ['./vehicle-service-details-tab-requests.component.scss'],
  providers: [],
})
export class VehicleDetailsTabRequestsComponent extends ABaseComponent {
  _vehicleService: VehicleService;

  @Input()
  set vehicleService(v: VehicleService) {
    this._vehicleService = v;
    this.changeHandle();
  }

  get vehicleService() {
    return this._vehicleService;
  }

  dso: DataSourceOptions;

  constructor(
    protected logger: LoggerService,
    protected ui: UiService,
    protected dss: DataSourceService,
    protected dialog: MatDialog,
    public helperService: HelperService,
    @Inject(LoopBackAuth) private auth: ExtLoopBackAuth,
  ) {
    super(logger);
  }

  changeHandle() {}

  async resolveRequest(request: any): Promise<void> {
    try {
      request.resolvedAt = new Date();

      const { requests } = this.vehicleService;
      const index = requests.findIndex((rep: any) => rep.id === request.id);
      if (index !== -1) {
        requests[index] = { ...requests[index], resolvedAt: request.resolvedAt };
        const { requests: updatedRequests } = await this.dss
          .getApi<VehicleServiceApi>(VehicleService)
          .mySaveWithRelated(this.vehicleService.id, { requests })
          .toPromise();
        this.vehicleService.requests = updatedRequests;
        notify('Request resolved successfully', 'success', 3000);
      }
    } catch (error) {
      notify('Error resolving request', 'error', 3000);
      console.error('Error resolving request:', error);
    }
  }

  async onRequestInserting(event: any): Promise<void> {
    try {
      event.data.id = event.data.__KEY__;
      event.data.createdAt = new Date();
      event.data.requiresService = event.data.requiresService || false;
      event.data.allowOperation = event.data.allowOperation || false;
      const { id, username } = this.auth.getCurrentUserData();
      event.data.createdBy = { id, username };

      let { requests } = this.vehicleService;
      requests = [{ ...event.data, __KEY__: undefined }, ...this.vehicleService.requests];
      this.vehicleService.requests = requests; // Update the local state with predicted data

      // Call the API to add the new request
      const updatedVehicleService = await this.dss
        .getApi<VehicleServiceApi>(VehicleService)
        .mySaveWithRelated(this.vehicleService.id, { requests })
        .toPromise();

      // Update the local state with the response
      this.vehicleService.requests = updatedVehicleService.requests;
    } catch (error) {
      notify('Error inserting request', 'error', 3000);
      console.error('Error inserting request:', error);
      event.cancel = true;
    }
  }

  async onRequestUpdating(event: any): Promise<void> {
    try {
      const { requests } = this.vehicleService;
      const index = requests.findIndex((rep: any) => rep.id === event.key.id);
      if (index !== -1) {
        requests[index] = { ...requests[index], ...event.newData, updatedAt: new Date() };
        const { requests: updatedRequests } = await this.dss
          .getApi<VehicleServiceApi>(VehicleService)
          .mySaveWithRelated(this.vehicleService.id, { requests })
          .toPromise();
        this.vehicleService.requests = updatedRequests;
      }
    } catch (error) {
      notify('Error updating request', 'error', 3000);
      console.error('Error updating request:', error);
      event.cancel = true;
    }
  }

  async onRequestRemoving(event: any): Promise<void> {
    const { requests } = this.vehicleService;
    const index = requests.findIndex((rep: any) => rep.id === event.key.id);
    if (index !== -1) {
      requests.splice(index, 1);
      const { requests: updatedRequests } = await this.dss
        .getApi<VehicleServiceApi>(VehicleService)
        .mySaveWithRelated(this.vehicleService.id, { requests })
        .toPromise();
      this.vehicleService.requests = updatedRequests;
    }
  }
}
